import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WsContactusService } from 'src/app/ws/wsContactUs/ws-contactus.service';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  contactUsForm: FormGroup;
  get contactUsf() {
    return this.contactUsForm.controls;
  }
  constructor(private formBuilder: FormBuilder, private wsContactUsService: WsContactusService, private toast: ToastrService, private _commonBehaviorChangeService: CommonBehaviorChangeService) {
    this.contactUsForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      subject: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      message: ['', [Validators.required]]
    })
  }

  async submitContactUsForm() {
    const submitContactUsForm = this.wsContactUsService.submitContactUsForm(this.contactUsForm.value)
    await lastValueFrom(submitContactUsForm).then(async response => {
      if (response && response.statusCode == 200) {
        this._commonBehaviorChangeService.getToast("Submitted Successfully")
        this.contactUsForm.reset();
        this.contactUsForm.markAsUntouched();
      } else {
        this.toast.error("Something went wrong. Please try once again!");
      }
    })
  }
}
